<ul class="breadcrumb">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>Department</li>
  </ul>
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong>Department</strong>
      </span>
      <span style="float:right">
        <button class="btn btn-sm btn-primary mb-2" type="button"  (click)="add()">
          <i class="fa fa-plus"></i>&nbsp;Add Department</button>
      </span>
    </div>
  
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-lg-12">
          <div class="table-responsive">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border nowrap"
            id="groupTable" style="cursor: pointer;width:-webkit-fill-available !important;">
              <thead>
                <tr>
                  <th>Department Name </th>
                  <th>Department Id</th>
                  <th>Email Id</th>
                  <th>Escalation 1</th>
                  <th>Escalation 2</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let department of responseDepartment; let count=index" style="line-height: 25px;"
                  class="highligh-Committee">
                  <td tabindex="1">{{department.departmentName}}</td>
                  <td tabindex="1">{{department.departmentId}}</td>
                  <td tabindex="1">{{department.emailId}}</td>
                  <td tabindex="1">{{department.escalation_1 || 'N/A'}}</td>
                  <td tabindex="1">{{department.escalation_2 || 'N/A'}}</td>
                  <td tabindex="1">
                    <button type="button" class="btn btn-sm btn-primary" (click)="onEdit(department)">
                      <i class="fa fa-edit"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-danger" (click)="onDeleteDepartment(department._id)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
  
            <div class="modal fade show" id="departmentModel" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
  
                <div class="well">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabel">
                        <i class="fa fa-plus"></i>&nbsp;Department Setup
                      </h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" (click)="restForm()" type="button">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
  
                    <div class="modal-body" [formGroup]="departmentForm">
                      <div class="row">
                        <div class="col-md-4">
                          <label class="form-control-label" for="l0">Department Name</label>
                          <span style="color: red;">*</span>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <input id="departmentName" maxlength="100" type="text" name="departmentName" formControlName="departmentName"
                              class="form-control" style="padding:6px;" (change)="onChange('departmentName', $event)"/>
                            <div
                              *ngIf="(departmentForm.controls['departmentName'].hasError('required') || departmentForm.controls['departmentName'].hasError('whitespace')) && departmentForm.controls['departmentName'].touched  "
                              class="form-control-error-custom">
                              Department Name is required
                            </div>
                            <div *ngIf="errorMessage?.departmentName" class="form-control-error-custom">
                              {{errorMessage?.departmentName}}
                            </div>
                          </div>
                        </div>
  
                        <div class="col-md-4">
                          <label class="form-control-label">Department Id
                            <span style="color: red;">*</span>
                          </label>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <input id="departmentId" type="text" maxlength="25" name="departmentId" formControlName="departmentId"
                              class="form-control" style="padding:6px;" (change)="onChange('departmentId', $event)">
                            <div
                              *ngIf="(departmentForm.controls['departmentId'].hasError('required') || departmentForm.controls['departmentId'].hasError('whitespace')) && departmentForm.controls['departmentId'].touched "
                              class="form-control-error-custom">
                              Department ID is required.
                            </div>
                            <div *ngIf="errorMessage?.departmentId" class="form-control-error-custom">
                              {{errorMessage?.departmentId}}
                            </div>
                          </div>
                        </div>
  
                        <div class="col-md-4">
                          <label class="form-control-label">Email Id
                          </label>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <input id="emailId" type="text" name="emailId" formControlName='emailId' class="form-control"
                              style="padding:6px;">
                            <div
                              *ngIf="(departmentForm.controls['emailId'].hasError('pattern') || departmentForm.controls['emailId'].hasError('pattern')) && departmentForm.controls['emailId'].touched"
                              class="form-control-error-custom">
                              Please Enter correct Email.
                            </div>
                          </div>
                        </div>
  
                        <div class="col-md-4">
                          <label class="form-control-label">Escalation 1
                          </label>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <input id="escalation_1" type="text" name="escalation_1" formControlName='escalation_1'
                              class="form-control" style="padding:6px;">
                            <div
                              *ngIf="(departmentForm.controls['escalation_1'].hasError('pattern') &&  departmentForm.controls['escalation_1'].hasError('pattern')&& departmentForm.controls['escalation_1'].touched )"
                              class="form-control-error-custom">
                              Please Enter correct Escalation 1
                            </div>
                          </div>
                        </div>
  
  
                        <div class="col-md-4">
                          <label class="form-control-label">Escalation 2
                          </label>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <input id="escalation_2" type="text" name="escalation_2" formControlName='escalation_2'
                              class="form-control" style="padding:6px;">
                            <div
                              *ngIf="(departmentForm.controls['escalation_2'].hasError('pattern') || departmentForm.controls['escalation_2'].hasError('pattern')) && departmentForm.controls['escalation_2'].touched "
                              class="form-control-error-custom">
                              Please Enter correct Escalation 2
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button id="btnsaveDepartment" type="submit" class="btn btn-sm btn-primary"
                        [disabled]="!departmentForm.valid" (click)="onSave()">
                        <i class="fa fa-save"></i>&nbsp;Save
                      </button>
                      <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="restForm()">
                        <i class="fa fa-times"></i>&nbsp;Close</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div id="alertTitle" class="modal-header"
                    style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                    Title!
                  </div>
                  <div class="modal-body" style="padding: 10px 15px;">
                    <div id="alertMessage" style="font-size: 16px;">
                      Message..
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="modal fade show" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDelete">
                      <i class="fa fa-question-circle-o mr-2"></i>Confirm
                    </h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-sm-12">
                        Are you sure you want to delete this Department?
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="deleteDepartment()">
                      <i class="fa fa-check"></i>&nbsp;Yes
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                      <i class="fa fa-times"></i>&nbsp;No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-alert></app-alert>
  </section>